import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParametroGapDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';

@Injectable()
export class ParametroGapApiClient extends BaseCRUDApiClient<ParametroGapDto> {
  baseUrl = this.config.apiEndpoint + '/parametro-gap';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
